import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { routerPropTypes } from 'Types'
import get from 'lodash/get'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { trackLink, removeFavourite } from 'Actions'
import { PageView, PageHelmet, TrackLinkDecrease, StoreLocation } from 'Blocks'
import { PAGE_CONTEXT as p } from 'Constants'
import config from 'Config'
import Component from './component'
import NoMatch from '../NoMatch'
import { skin } from 'Utils'
import skins from './skins'

const pageName = p.FAVOURITES

const isClient = typeof window !== 'undefined'

export const NoFavourites = ({ className }) => (
  <div className={`main-container ${className}`}>
    <div className="content">
      <h1 className="favourites__heading">Your Favourites</h1>
      <h2 className="sub-heading">
        Items added to your Favourites will be saved here.
      </h2>
    </div>
  </div>
)

NoFavourites.propTypes = {
  className: PropTypes.string
}

const FavouritesContainer = props => {
  const { removeFavourite, favouritesUuids = [], location } = props

  if (!config.favouritesEnabled) return <NoMatch {...props} />

  if (favouritesUuids.length < 1) return <NoFavourites {...props} />

  return (
    <Fragment>
      <PageView url={location.pathname} />
      <PageHelmet
        htmlAttributes={{ class: 'favourites' }}
        pageName={pageName}
      />
      <TrackLinkDecrease url={location.pathname} />
      <StoreLocation location={location} />
      <Component
        {...props}
        uuids={favouritesUuids}
        removeFavourite={removeFavourite}
      />
    </Fragment>
  )
}

FavouritesContainer.propTypes = {
  removeFavourite: PropTypes.func,
  favouritesUuids: PropTypes.array,
  ...routerPropTypes
}

const mapStateToProps = state => ({
  favouritesUuids: get(state, 'UI.favourites.uuids', []),
  screenType: state.UI.screenType
})

const mapDispatchToProps = dispatch => ({
  trackLink: bindActionCreators(trackLink, dispatch),
  removeFavourite: bindActionCreators(removeFavourite, dispatch),
  dispatch
})

const Page = isClient ? FavouritesContainer : NoFavourites

export default connect(mapStateToProps, mapDispatchToProps)(skin(Page, skins))
